import React, { Fragment, useState } from 'react';
import { withStyles } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';

const DARK_TOOLTIP_COLOR = '#333';
const ABOVE_EVERYTHING_Z_INDEX = 2147483647;

const styles = () => ({
  popper: {
    zIndex: ABOVE_EVERYTHING_Z_INDEX,
    opacity: 1,
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      marginTop: '-0.9em',
      '&::before': {
        borderWidth: '0 1em 1em 1em',
        borderColor: 'transparent transparent currentColor transparent'
      }
    },
    '&[x-placement*="top"] $arrow': {
      bottom: 0,
      marginBottom: '-0.9em',
      '&::before': {
        borderWidth: '1em 1em 0 1em',
        borderColor: 'currentColor transparent transparent transparent'
      }
    }
  },
  arrow: {
    position: 'absolute',
    left: 0,
    fontSize: 7,
    width: '3em',
    height: '1em',
    '&::before': {
      content: '""',
      margin: 'auto',
      display: 'block',
      width: 0,
      height: 0,
      borderStyle: 'solid'
    }
  },
  light: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.9)',
    maxWidth: 400,
    fontSize: '1rem',
    border: '1px solid #dadde9',
    '& b': {
      fontWeight: '400'
    },
    '& $arrow': {
      color: '#f5f5f9'
    }
  },
  dark: {
    backgroundColor: DARK_TOOLTIP_COLOR,
    color: '#fff',
    maxWidth: 800,
    borderRadius: 4,
    fontSize: '0.95rem',
    padding: '0.4rem 0.8rem',
    textAlign: 'left',
    '& a': {
      color: '#cfef4a'
    },
    '& $arrow': {
      color: DARK_TOOLTIP_COLOR
    }
  }
});

const CustomTooltip = ({ arrow = false, classes, children, className, content, placement = 'bottom', variant = 'light' }) => {
  const [ arrowElement, setArrowElement ] = useState(null);

  return (
    <Tooltip
      PopperProps={{
        popperOptions: {
          modifiers: {
            arrow: { enabled: Boolean(arrowElement), element: arrowElement }
          }
        }
      }}
      classes={{ popper: classes.popper, tooltip: classes[variant] }}
      placement={placement}
      title={
        <Fragment>
          {content}
          {arrow && <span className={classes.arrow} data-testid='tooltip-arrow' ref={setArrowElement} />}
        </Fragment>
      }
    >
      <div className={className} style={{ display: 'inline' }}>
        {children}
      </div>
    </Tooltip>
  );
};

export default withStyles(styles)(CustomTooltip);
